"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Render;
var _react = _interopRequireDefault(require("react"));
var _PublishPrice = _interopRequireDefault(require("../PublishPrice"));
var _PackageSwitch = _interopRequireDefault(require("../PackageSwitch"));
var _PackageCard = _interopRequireDefault(require("../PackageCard"));
function Render(props) {
  var _a = props.item,
    item = _a === void 0 ? {} : _a;
  var _b = item.list,
    list = _b === void 0 ? [] : _b;
  var _c = list[0],
    headerList = _c.headerList,
    itemList = _c.itemList,
    headerTitle = _c.headerTitle,
    packageSwitchList = _c.packageSwitchList,
    packageSwitchConfiguration = _c.packageSwitchConfiguration,
    packageCardConfiguration = _c.packageCardConfiguration,
    packageCardTitle = _c.packageCardTitle,
    publishPriceTitle = _c.publishPriceTitle,
    packageSwitchTitle = _c.packageSwitchTitle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-render-wrap"
  }, (itemList === null || itemList === void 0 ? void 0 : itemList.length) > 0 ? ( /*#__PURE__*/_react["default"].createElement(_PublishPrice["default"], {
    mainList: itemList,
    headerList: headerList,
    headerTitle: headerTitle,
    title: publishPriceTitle
  })) : null, (packageSwitchConfiguration === null || packageSwitchConfiguration === void 0 ? void 0 : packageSwitchConfiguration.length) > 0 ? ( /*#__PURE__*/_react["default"].createElement(_PackageSwitch["default"], {
    list: packageSwitchList,
    configuration: packageSwitchConfiguration,
    title: packageSwitchTitle
  })) : null, (packageCardConfiguration === null || packageCardConfiguration === void 0 ? void 0 : packageCardConfiguration.length) > 0 ? ( /*#__PURE__*/_react["default"].createElement(_PackageCard["default"], {
    configuration: packageCardConfiguration,
    title: packageCardTitle
  })) : null);
}